import { render, staticRenderFns } from "./allinpay_member_list.vue?vue&type=template&id=c2d3c348&scoped=true"
import script from "./allinpay_member_list.vue?vue&type=script&lang=js"
export * from "./allinpay_member_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d3c348",
  null
  
)

export default component.exports